<template>
  <div id="summaryIndex" class="summaryIndex">
    <div class="list-bj">
      <div class="list-item orange" @click="clkxShow('TransitInfo')">
        <i :class="{ 'el-icon-arrow-down': !transitShow, 'el-icon-arrow-up': transitShow}" /> <span
          class="item-name"
        >Transit Information</span>
        <!--        <div class="red-tip">
          <img src="../../../../../../assets/img/client/感叹号@2x(1).png" width="12px" height="12px">
          <span>SHIPMENT ON HOLD</span>
        </div> -->
      </div>
      <div class="list-card">
        <TransitInfo v-if="transitShow" ref="TransitInfo" />
      </div>
    </div>
    <div class="list-bj">
      <div class="list-item black" @click="clkxShow('Documents')">
        <i :class="{ 'el-icon-arrow-down': !documentsShow, 'el-icon-arrow-up': documentsShow}" /> <span
          class="item-name"
        >Documents</span>
      </div>
      <div v-if="documentsShow" class="list-card">
        <Documents ref="Documents" />
      </div>
    </div>
    <div class="list-bj">
      <div class="list-item black" @click="clkxShow('Summary')">
        <i :class="{ 'el-icon-arrow-down': !summaryShow, 'el-icon-arrow-up': summaryShow}" /> <span
          class="item-name"
        >Summary</span>
      </div>
      <div v-if="summaryShow" class="list-card">
        <Summary ref="Summary" />
      </div>
    </div>
    <div class="list-bj">
      <div class="list-item black" @click="clkxShow('Contacts')">
        <i :class="{ 'el-icon-arrow-down': !contactsShow, 'el-icon-arrow-up': contactsShow}" /> <span
          class="item-name"
        >Consignor And Consignee</span>
      </div>
      <div v-if="contactsShow" class="list-card">
        <Contacts ref="Contacts" />
      </div>
    </div>
  </div>
</template>

<script>
import Summary from './Summary.vue'
import Documents from './documents.vue'
import Contacts from './Contacts.vue'
import TransitInfo from './TransitInfo.vue'
export default {
  name: 'SummaryIndex',
  components: {
    // 组件的引用
    Summary,
    Documents,
    TransitInfo,
    Contacts
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      list: [{
        name: 'Transit Information',
        isTrue: false,
        type: 'TransitInfo',
        disaled: true
      },
      {
        name: 'Documents',
        isTrue: false,
        type: 'Documents',
        disaled: true
      },
      {
        name: 'Summary',
        isTrue: true,
        type: 'Summary',
        disaled: false
      },
      {
        name: 'Consignor And Consignee',
        isTrue: false,
        type: 'Contacts',
        disaled: true
      }
      ],
      data: {},
      selectList: [],
      transitInfoEabled: false,
      documentsEabled: false,
      contactsEabled: false,
      transitShow: false,
      documentsShow: false,
      contactsShow: false,
      summaryShow: true
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    init(data) {
      this.data = data
      if (data.status > 1 && data.status < 7) {
        this.transitInfoEabled = true
        this.documentsEabled = true
        this.contactsEabled = true
      } else {
        this.transitInfoEabled = false
        this.documentsEabled = false
        this.contactsEabled = false
      }
      this.$nextTick(() => {
        this.$refs.Summary.init(data)
      })
    },
    clkxShow(type) {
      switch (type) {
        case 'TransitInfo':
          if (this.transitInfoEabled) {
            this.transitShow = !this.transitShow
            if (this.transitShow) {
              this.$nextTick(() => {
                this.$refs.TransitInfo.init(this.data)
              })
            }
          }
          break
        case 'Documents':
          if (this.transitInfoEabled) {
            this.documentsShow = !this.documentsShow
            if (this.documentsShow) {
              this.$nextTick(() => {
                this.$refs.Documents.init(this.data)
              })
            }
          }
          break
        case 'Summary':
          if (this.transitInfoEabled) {
            this.summaryShow = !this.summaryShow
            if (this.summaryShow) {
              this.$nextTick(() => {
                this.$refs.Summary.init(this.data)
              })
            }
          }
          break
        case 'Contacts':
          if (this.transitInfoEabled) {
            this.contactsShow = !this.contactsShow
            if (this.contactsShow) {
              this.$nextTick(() => {
                this.$refs.Contacts.init(this.data)
              })
            }
          }
          break
      }
    }
  }
}
</script>
<style scoped lang='scss'>
	.summaryIndex {
		width: 1200px;
		height: auto;
		background: #FFFFFF;
		border-radius: 8px;
		margin-top: 16px;

		.list-bj {
			.list-item {
				cursor: pointer;
				text-align: left;
				height: 48px;
				line-height: 48px;
				padding-left: 8px;
				display: flex;
				align-items: center;

				.red-tip {
					display: flex;
					align-items: center;
					justify-content: center;
					width: 156px;
					height: 24px;
					background: rgba(239, 10, 10, 0.04);
					border-radius: 12px;
					margin-left: 16px;

					span {
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 12px;
						color: #EF0A0A;
						margin-left: 4px;
					}
				}

				.item-name {
					font-size: 14px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					color: #AAAAAA;
				}
			}
		}
	}
</style>
